import { defineComponent } from 'vue';
import ImageInfomation from '@/components/ImageInfomation.vue';
import info1Image from '@/assets/image/home/info/1.jpg';
import info2Image from '@/assets/image/home/info/2.jpg';
import info3Image from '@/assets/image/home/info/3.jpg';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'HomeContestInfomation',
  components: {
    ImageInfomation: ImageInfomation
  },
  setup: function () {
    var info1 = {
      newsCover: info1Image,
      newsUrl: '',
      newsTitle: '第十九届NOC省赛（陕西赛区）——核桃编程马拉松',
      newsSummary: 'NOC大赛是经教育部批准的2020-2021学年面向中小学生的全国性竞赛活动。核桃编程受邀成为本届大赛的技术支持单位，全程提供赛项策划、活动平台设计等多项技术支持。'
    };
    var info2 = {
      newsCover: info2Image,
      newsUrl: '',
      newsTitle: '核桃编程携手淘宝教育打造编程少年团',
      newsSummary: ''
    };
    var info3 = {
      newsCover: info3Image,
      newsUrl: '',
      newsTitle: '京东教育x核桃编程：首届未来之星青少年编程挑战',
      newsSummary: ''
    };
    var router = useRouter();
    var goToInfoList = function () {
      router.push({
        name: 'ItemInfo'
      });
    };
    return {
      info1: info1,
      info2: info2,
      info3: info3,
      goToInfoList: goToInfoList
    };
  }
});